// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":" chevron-up-s"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M8.46436 13.2655L11.9999 9.73L15.5354 13.2655","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-chevron-up-s')
export default class ChevronUpSIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chevron-up-s',
    }
  }
}
